import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import { ContentState } from './types';
import { setFontPack, setThemePack } from '../templates';
import handleThemePackMutations from './helpers/handle-theme-pack-mutations';
import handleFontPackMutations from './helpers/handle-font-pack-mutations';

export const extraReducers = (builder: ActionReducerMapBuilder<ContentState>) => {
  /* if we update a theme pack that lives in the templates slice, we need to make sure we update the content slice too */
  builder.addCase(setThemePack, (state, action) => {
    handleThemePackMutations(action.payload, state);
  });
  /* if we update a font pack that lives in the templates slice, we need to make sure we update the content slice too */
  builder.addCase(setFontPack, (state, action) => {
    handleFontPackMutations(action.payload, state);
  });
};
